<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        id="kt_wizard_v2"
        class="wizard wizard-2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right px-lg-10">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/tutorial/one.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">Đăng nhập tài khoản Facebook</h3>
                  <div class="wizard-desc">
                    Sử dụng tài khoản Facebook của bạn để kết nối với fanpage
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/tutorial/two.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Lựa chọn Fan Page mà bạn muốn tương tác
                  </h3>
                  <div class="wizard-desc">
                    Chỉ những page được chọn mới được sử dụng trong SRC
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" href="#" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/tutorial/three.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    Cấp quyền cho ứng dụng sử dụng dữ liệu từ Fan Page
                  </h3>
                  <div class="wizard-desc">
                    SRC cần tất cả các quyền này để có thể truy xuất, tính toán
                    các tiêu chí
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="media/tutorial/warn.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">Chọn lại Fan Page</h3>
                  <div class="wizard-desc">
                    Nếu bạn muốn chọn lại, chọn thêm Fan Page. Vui lòng log in
                    lại và chọn Edit Settings
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <!--begin: Wizard Step 1-->
            <div
              class="pb-5"
              data-wizard-type="step-content"
              data-wizard-state="current"
            >
              <div class="row">
                <div class="col-xl-12">
                  <b-img
                    fluid
                    src="media/tutorial/step_1.png"
                    alt="Hướng dẫn bước 1"
                  />
                </div>
              </div>
            </div>
            <!--end: Wizard Step 1-->

            <!--begin: Wizard Step 2-->
            <div class="pb-5" data-wizard-type="step-content">
              <div class="row">
                <div class="col-xl-12">
                  <b-img
                    fluid
                    src="media/tutorial/step_2.png"
                    alt="Hướng dẫn bước 2"
                  />
                </div>
              </div>
            </div>
            <!--end: Wizard Step 2-->

            <!--begin: Wizard Step 3-->
            <div class="pb-5" data-wizard-type="step-content">
              <div class="row">
                <div class="col-xl-12">
                  <b-img
                    fluid
                    src="media/tutorial/step_3.png"
                    alt="Hướng dẫn bước 3"
                  />
                </div>
              </div>
            </div>
            <!--end: Wizard Step 3-->

            <!--begin: Wizard Step 4-->
            <div class="pb-5" data-wizard-type="step-content">
              <div class="row">
                <div class="col-xl-12">
                  <b-img
                    fluid
                    src="media/tutorial/step_4.png"
                    alt="Chọn lại thiết lập"
                  />
                </div>
              </div>
            </div>
            <!--end: Wizard Step 4-->
          </div>
          <!--end: Wizard-->
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-2.scss';
</style>

<script>
import KTUtil from '@/assets/js/components/util';
import KTWizard from '@/assets/js/components/wizard';
import Swal from 'sweetalert2';

export default {
  name: 'HashtagCounterWizard',
  mounted() {
    // Initialize form wizard
    const wizard = new KTWizard('kt_wizard_v2', {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    wizard.on('beforeNext', function (/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  methods: {
    submit: function (e) {
      e.preventDefault();
      Swal.fire({
        title: '',
        text: 'The application has been successfully submitted!',
        icon: 'success',
        confirmButtonClass: 'btn btn-secondary'
      });
    }
  }
};
</script>
